<template>
  <div>
    <div
      class="title d-flex flex-wrap align-center primary--text font-weight-medium gap-2 mb-4">
      <v-icon
        size="20"
        class="mr-2"
        color="primary">
        mdi-note-edit
      </v-icon>
      <div>จัดการแบรนด์</div>
      <v-spacer />
      <div class="d-flex gap-2">
        <div class="font-weight-regular">
          <v-text-field
            :value="searchText"
            placeholder="ค้นหาแบรนด์"
            append-icon="mdi-magnify"
            autocomplete="off"
            background-color="#ffffff"
            hide-details
            outlined
            dense
            @input="setSearchTextDebounce($event)" />
        </div>
        <UpdateDialog
          :is-update="false"
          @onRefetch="onRefetch()" />
      </div>
    </div>
    <v-card
      class="p-5 rounded-lg"
      flat>
      <div class="d-flex justify-space-between">
        <div class="title primary--text mb-5">
          รายการแบรนด์ ({{ productBrandList.nodesCount }})
        </div>
        <DeleteDialog
          v-if="selected.length > 0"
          :brand-list="selected"
          @onRefetch="onRefetch()"
          @deleteSuccess="clearSelect()" />
      </div>
      <v-data-table
        v-model="selected"
        class="elevation-0 brand-table"
        :loading="loading"
        :headers="headers"
        :items="productBrandList.nodes"
        :items-per-page="perPage"
        :page="page"
        checkbox-color="primary"
        show-select
        hide-default-footer>
        <template #[`item.action`]="{ item }">
          <div class="d-flex justify-center align-center">
            <UpdateDialog
              :brand-name="item.name"
              :brand-id="item.id"
              :is-update="true" />
            <DeleteDialog
              :brand-name="item.name"
              :brand-id="item.id"
              @onRefetch="onRefetch()"
              @deleteSuccess="clearSelect()" />
          </div>
        </template>
        <template #footer>
          <snt-pagination
            v-model="page"
            :total-pages="productBrandList.pagesCount" />
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { GET_PRODUCT_BRAND_LIST } from '@/resources/graphql'
import DeleteDialog from './components/DeleteDialog.vue'
import UpdateDialog from './components/UpdateDialog.vue'

export default {
  components: {
    DeleteDialog,
    UpdateDialog
  },
  apollo: {
    productBrandList: {
      fetchPolicy: 'network-only',
      query: GET_PRODUCT_BRAND_LIST,
      variables () {
        return {
          page: this.page,
          perPage: this.perPage,
          search: this.searchText,
          sort: 'name_ASC'
        }
      }
    }
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API,
      headers: [
        {
          text: 'ชื่อแบรนด์',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'จำนวนสินค้า',
          align: 'end',
          sortable: false,
          value: 'productsCount'
        },
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'action',
          width: '20%'
        }
      ],
      productBrandList: {
        nodes: [],
        nodesCount: 0,
        pagesCount: 1
      },
      selected: [],
      page: 1,
      perPage: 10,
      searchText: ''
    }
  },
  computed: {
    loading () {
      return this.$apollo.queries.productBrandList.loading
    }
  },
  created () {
    this.setSearchTextDebounce = this.$_.debounce((text) => {
      this.setSearchText(text)
      this.page = 1
    }, 800)
  },
  methods: {
    clearSelect () {
      this.selected = []
    },
    setSearchText (searchText = '') {
      this.searchText = searchText
    },
    async onRefetch () {
      await this.$apollo.queries.productBrandList.refetch()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .mdi-checkbox-blank-outline {
  color: #b5b5b5;
}
::v-deep {
  .v-data-table-header {
    background: #f6f6f6;

      span {
      font-size: 16px;
    }

  }

  .v-data-table__mobile-row:nth-child(1) .v-data-table__mobile-row__header {
    display: none;
  }
}
.v-data-table {

  ::v-deep {
    tr {
      &:hover,
      &.v-data-table__selected {
        background-color: transparent !important;
      }
      td,
      th {
        padding-left: 12px !important;
        padding-right: 12px !important;
        &:not(.v-data-table__mobile-row):nth-child(1),
        &:not(.v-data-table__mobile-row):nth-child(2) {
          @media (max-width: 640px) {
            padding-left: 0px !important;
          }
          padding-left: 60px !important;
        }
      }
      td:not(.v-data-table__mobile-row) {
        padding-top: 14px !important;
        padding-bottom: 14px !important;
      }
    }
  }
}
</style>
